import React from 'react';
import ProfessionalFloorplanEditor from '../components/ProfessionalFloorplanEditor';

const FloorplanEditorPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-black">
      <ProfessionalFloorplanEditor />
    </div>
  );
};

export default FloorplanEditorPage;
